<template>
    <div>是晨检编辑啊</div>
</template>

<script>
    export default {
        name: "inspectEdit"
    }
</script>

<style scoped>

</style>